import { render } from "./ShowVente.vue?vue&type=template&id=71e0dc65"
import script from "./ShowVente.vue?vue&type=script&lang=js"
export * from "./ShowVente.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__